// Одна шкала времени для графиков, полос проверок и видео сессии.
//
// t — время trace в секундах (t_ms / 1000, ms от первого кадра RUNNING).
// Видео начинается с кадра startMs: его pts = t_ms − startMs, файл идёт с 0,
// поэтому videoTime = t − startMs / 1000.
// frac — доля ширины области графика (0 — первый кадр trace, 1 — последний).

// Поля графика: ось Y слева, отступ справа (как у LineChart на странице).
export const PLOT_INSETS = { left: 48, right: 16 };

const clamp01 = (x) => Math.min(1, Math.max(0, x));
const safeSpan = (span) => (span > 0 ? span : 0.001);

/** Доля ширины для времени t. Не обрезается: вне [0, 1] курсор прячут. */
export const fracOfT = (t, t0, span) => (t - t0) / safeSpan(span);

/** Время для доли ширины (обрезается до графика). */
export const tOfFrac = (frac, t0, span) => t0 + clamp01(frac) * span;

/** Доля ширины области графика под курсором мыши. */
export function fracFromClientX(clientX, rect, insets = PLOT_INSETS) {
  const width = rect.width - insets.left - insets.right;
  if (!(width > 0)) return 0;
  return clamp01((clientX - rect.left - insets.left) / width);
}

export const videoTimeOfT = (t, startMs) => t - startMs / 1000;
export const tOfVideoTime = (v, startMs) => v + startMs / 1000;

// Кадр видео держится от своего pts до следующего; цель чуть позже pts, чтобы
// округление в плеере не показало предыдущий кадр.
export const seekTarget = (v) => Math.max(0, v) + 0.0005;

/** Индекс строки trace, ближайшей по времени к t (с); −1, если кадров нет. */
export function nearestIndex(columns, t) {
  const times = columns.t_ms;
  const n = times.length;
  if (n === 0) return -1;
  const ms = t * 1000;
  let lo = 0;
  let hi = n - 1;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (times[mid] < ms) lo = mid + 1;
    else hi = mid;
  }
  // lo — первый кадр не раньше ms; сравниваем с предыдущим (ничья — ему).
  if (lo > 0 && ms - times[lo - 1] <= times[lo] - ms) lo -= 1;
  return lo;
}

/** Номер кадра trace, ближайшего по времени к t (с); null, если кадров нет. */
export function nearestFrame(columns, t) {
  const i = nearestIndex(columns, t);
  return i < 0 ? null : columns.frame[i];
}
